'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAjaxDebugState = exports.createAxios = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _httpInterceptors = require('./httpInterceptors');

var _httpInterceptors2 = _interopRequireDefault(_httpInterceptors);

var _createTransformRequest = require('./createTransformRequest');

var _createTransformRequest2 = _interopRequireDefault(_createTransformRequest);

var _createParamsSerializer = require('./createParamsSerializer');

var _createParamsSerializer2 = _interopRequireDefault(_createParamsSerializer);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// options默认值
var defaultOptions = {
  AuthorizationKey: 'AuthorizationV2',
  tokenKey: 'token',
  ignoreErrorCode: false, // 是否忽略处理接口自定义错误码
  errorCodeKey: 'code',
  errorCodeOkValue: 0,
  setHeaderAuth: true, // 是否设置headers Authorization
  setBodyAuth: true, // 是否设置body Authorization
  useRawData: false,
  userDefinedResponse: false, // 是否允许用户返回自定义的response

  enableTrace: false, // 是否开启请求头部设置 trace 相关字段
  traceSampler: 0, // 在开启 trace 的基础上，设置采样开关：0为关闭;  1为开启
  needBase64Keys: [], // 需要做base64编码的头部字段名单
  enableBase64: false, // 是否开启对 needBase64Keys 中的头部值进行 base64 编码

  handleRequestData: _util.noop,
  handleRequestError: _util.noop,
  handleResponseData: _util.noop,
  handleResponseError: _util.noop,
  transformRequest: null
};

var createAxios = exports.createAxios = function createAxios() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // options = Object.assign({}, defaultOptions, options)
  options = _extends({}, defaultOptions, options);

  var _options = options,
      AuthorizationKey = _options.AuthorizationKey,
      tokenKey = _options.tokenKey,
      transformRequest = _options.transformRequest,
      setBodyAuth = _options.setBodyAuth;


  var instance = _axios2.default.create(_extends({
    timeout: 15000,
    paramsSerializer: (0, _createParamsSerializer2.default)({
      AuthorizationKey: AuthorizationKey, tokenKey: tokenKey, transformRequest: transformRequest, setBodyAuth: setBodyAuth
    }),
    transformRequest: (0, _createTransformRequest2.default)({
      AuthorizationKey: AuthorizationKey, tokenKey: tokenKey, transformRequest: transformRequest, setBodyAuth: setBodyAuth
    })
  }, settings));
  // 设置默认值
  instance.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

  instance.rawGet = instance.get.bind(instance);

  // params为空时，不会触发paramsSerializer，给个默认值{}
  instance.get = function (url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return instance.rawGet(url, _extends({ params: params }, config));
  };

  (0, _httpInterceptors2.default)(instance, _extends({}, options, {
    filterKey: AuthorizationKey // 过滤敏感key值
  }));
  return instance;
};

var setAjaxDebugState = exports.setAjaxDebugState = function setAjaxDebugState(bool) {
  console.warn('setAjaxDebugState is deprecated!');
};

exports.default = _axios2.default;